let Environment = {
  dop: "0x6DE6e0DF4F1D1cDb78Dbbd8EC1D246da00266778"
};

export default Environment;
